import React from 'react';
import { SELECT_VELOCITY_TYPE_PLACEHOLDER_TEXT, VELOCITY_TYPE } from 'Common/parameterEnums';
import { FastField, FieldProps, useFormikContext } from 'formik';
import { Select } from '@brighterion/br-ui';
import { uniqueId } from 'lodash';
import { useTranslation } from 'react-i18next';
import styles from './velocityType.css';

type Option = {
    disabled?: boolean;
    label: string;
    value: string;
    visible?: boolean;
};

type Options = Option[];

type Props = {
    readOnly: boolean;
};

const VelocityType = ({ readOnly }: Props) => {
    const { t } = useTranslation();
    const { isSubmitting } = useFormikContext<ParameterVelocityFormSchema>();

    const primaryOptions: Options = [
        { value: VELOCITY_TYPE.AVERAGE, label: t('Average') },
        { value: VELOCITY_TYPE.COUNT, label: t('Count') },
        { value: VELOCITY_TYPE.MAX, label: t('Max') },
        { value: VELOCITY_TYPE.MIN, label: t('Min') },
        { value: VELOCITY_TYPE.SUM, label: t('Sum') }
    ];

    return (
        <div className={styles.velocityTypeColumn}>
            <FastField name='velocityType'>
                {({ field, form: { setFieldValue } }: FieldProps) => {
                    return (
                        <Select
                            className={styles.velocityTypeDropdown}
                            size='sm'
                            label='Velocity Type'
                            placeholder={`${t(SELECT_VELOCITY_TYPE_PLACEHOLDER_TEXT)}`}
                            handleClickCallback={(value) => {
                                setFieldValue('aggregationField', []);
                                setFieldValue('timeField', '');
                                setFieldValue('timePeriod', { type: [], duration: 0, unit: [] });
                                setFieldValue('indexes', []);
                                setFieldValue('filters', []);
                                setFieldValue('type', '');

                                setFieldValue(field.name, value.toString());
                            }}
                            selectedItems={field.value ? [field.value] : []}
                            disabled={readOnly || isSubmitting}
                            aria-disabled={readOnly}
                        >
                            {primaryOptions.map(({ value, label }) => {
                                return (
                                    <option key={uniqueId(value)} value={value}>
                                        {label}
                                    </option>
                                );
                            })}
                        </Select>
                    );
                }}
            </FastField>
        </div>
    );
};

export default VelocityType;
